import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";

// Reducers
import { cartReducer } from "./reducers/cartReducers";
import { authReducer } from "./reducers/authReducers";
import { storeReducers } from "./reducers/storeReducers";
import { orderReducers } from "./reducers/orderReducers";
import { userReducers } from "./reducers/userReducers";
import {
  getProductsReducer,
  getProductDetailsReducer,
} from "./reducers/productReducers";
import { categoryReducers } from "./reducers/categoryReducers";
import { contactReducers } from "./reducers/contactReducers";

const reducer = combineReducers({
  cart: cartReducer,
  store: storeReducers,
  orders: orderReducers,
  user: authReducer,
  currentUser: userReducers,
  getProducts: getProductsReducer,
  getProductDetails: getProductDetailsReducer,
  category: categoryReducers,
  contact: contactReducers,
});

const middleware = [thunk];

const cartItemsInLocalStorage = localStorage.getItem("cart")
  ? JSON.parse(localStorage.getItem("cart"))
  : [];

const INITIAL_STATE = {
  cart: {
    cartItems: cartItemsInLocalStorage,
  },
};

const store = createStore(
  reducer,
  INITIAL_STATE,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
